export default "icons-logout"